/**
 * Created by r4zi4l on 05.04.2024
 */

Reward.register("lives", {
    currency: true,
    controls: "MenuBarLivesItem",
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.life_png;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.life_small_png;
    },

    getPrice: function (value) {
        return Reward.LIVES_PRICE * value;
    },

    receive: function (value, options) {
        const lives = LivesHelper.GetMainInstance() || cleverapps.lives;
        const displayed = lives === cleverapps.lives;
        lives.give(value, options.event, displayed);

        if (!displayed) {
            return;
        }

        return cleverapps.pendingRewards.add("lives", value, () => {
            lives.processRegenerateState(true);
            lives.trigger("changeAmount");
        });
    }
});

Reward.register("unlimitedLives", {
    ...Reward.TimeValue,
    controls: "MenuBarLivesItem",
    target: "lives",

    getIcon: function () {
        return bundles.reward_icons.frames.life_unlim;
    },

    getSmallIcon: function () {
        return bundles.reward_icons.frames.life_unlim_small;
    },

    receive: function (value) {
        cleverapps.unlimitedLives.buy(value.time);
        return function () {
            cleverapps.lives.trigger("buyUnlimitedLives");
        };
    }
});
